import { ApiResponse } from "apisauce";
import { IPagination } from "src/models/extensions/withPagination";
import { IColor, ICutoff } from '../../models/cutoff/Cutoff';
import { IResponseSnapshot } from '../../models';
import { Api } from "../api/api";
import { getGeneralApiProblem } from "../api/api-problem";
import {
  TDeleteCutoffResult,
  TGetColorsResult,
  TGetCutoffsResult,
  TPostCutoffResult,
  TUpdateCutoffResult,
  TGetCutoffListResult
} from "./CutoffTypes";

  /**
  * # Cutoff Api 서비스
  * 
  * 서비스의 설명을 작성하세요.
  * 
  * ## 사용방법
  * 
  * ```ts
  * const service = new CutoffApi();
  * 
  * ```
  */
 export class CutoffApi {
  private api: Api;

  constructor(api: Api) {
    this.api = api;
    this.api.setup();
  }

  private BASE_URL = '/cutoff';

  // 컷오프 목록조회
  async getCutoffList(paging:IPagination): Promise<TGetCutoffListResult> {
    try {
      const url = `${this.BASE_URL}`;
      const params = { size: paging.size, page: paging.page-1 };
      const response: ApiResponse<any> = await this.api.apisauce.get( url, params );
  
      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }

      const cutoffList: ICutoff[] = response.data.data;
      const pagination: IPagination = response.data.pagination;
      const responseInfo: IResponseSnapshot = response.data;
      return { kind: "ok", cutoffList, pagination, responseInfo:responseInfo };

    } catch (e) {
      return { kind: "bad-data" };
    }
  }

  async getCutoffAll(): Promise<TGetCutoffsResult> {
    try {
      const url = `${this.BASE_URL}/list`;
      const params = {};
      const response: ApiResponse<any> = await this.api.apisauce.get( url, params );
  
      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }

      const cutoffs: ICutoff[] = response.data.data;
      const responseInfo: IResponseSnapshot = response.data;
      return { kind: "ok", cutoffs, responseInfo:responseInfo };

    } catch (e) {
      return { kind: "bad-data" };
    }
  }

  // 컷오프 등록
  async postCutoff(data: ICutoff): Promise<TPostCutoffResult> {
    try {
      const url = `${this.BASE_URL}`;
      const payload = { ...data };
      const response: ApiResponse<any> = await this.api.apisauce.post( url, payload );
  
      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }

      const cutoff: ICutoff = response.data.data;
      const responseInfo: IResponseSnapshot = response.data;
      return { kind: "ok", cutoff, responseInfo: responseInfo };

    } catch (e) {
      return { kind: "bad-data" };
    }
  }

  // 컷오프 수정
  async updateCutoff(data:ICutoff): Promise<TUpdateCutoffResult> {
    try {
      const url = `${this.BASE_URL}/${data.cutoffSid}`;
      const payload = { ...data };
      const response: ApiResponse<any> = await this.api.apisauce.put( url, payload );
  
      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }

      const cutoff: ICutoff = response.data.data;
      const responseInfo: IResponseSnapshot = response.data;
      console.log("responseInfo : ", responseInfo)
      return { kind: "ok", cutoff, responseInfo: responseInfo };

    } catch (e) {
      return { kind: "bad-data" };
    }
  }

  // 컷오프 삭제
  async deleteCutoff(cutoffSid:number): Promise<TDeleteCutoffResult> {
    try {
      const url = `${this.BASE_URL}/${cutoffSid}`;
      const payload = {};
      const response: ApiResponse<any> = await this.api.apisauce.delete( url, payload );
  
      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }

      const responseInfo: IResponseSnapshot = response.data;
      return { kind: "ok", responseInfo:responseInfo };

    } catch (e) {
      return { kind: "bad-data" };
    }
  }

  // 컷오프 색상 목록 조회
  async getColorList(): Promise<TGetColorsResult> {
    try {
      const url = `${this.BASE_URL}/colors`;
      const params = {};
      const response: ApiResponse<any> = await this.api.apisauce.get( url, params );
  
      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }

      const colorList: IColor[] = response.data.data;
      const responseInfo: IResponseSnapshot = response.data;
      return { kind: "ok", colorList, responseInfo };

    } catch (e) {
      return { kind: "bad-data" };
    }
  }
}